export var UISocketMessage = 'UISocketMessage';
export var ControlType;
(function (ControlType) {
    ControlType["Stack"] = "Stack";
    ControlType["Row"] = "Row";
    ControlType["Column"] = "Column";
    ControlType["Grid"] = "Grid";
    ControlType["Form"] = "Form";
    ControlType["Textbox"] = "Textbox";
    ControlType["ContentAnchor"] = "ContentAnchor";
    ControlType["Box"] = "Box";
    ControlType["Select"] = "Select";
    ControlType["Checkbox"] = "Checkbox";
    ControlType["Button"] = "Button";
    ControlType["BottomMenu"] = "BottomMenu";
    ControlType["Tabs"] = "Tabs";
    ControlType["Tab"] = "Tab";
    ControlType["MenuBar"] = "MenuBar";
    ControlType["SummaryList"] = "SummaryList";
    ControlType["BorderBox"] = "BorderBox";
    ControlType["MultiStepInput"] = "MultiStepInput";
    ControlType["GenericSwitch"] = "GenericSwitch";
    ControlType["Component"] = "Component";
    ControlType["ButtonGroup"] = "ButtonGroup";
    ControlType["Upload"] = "Upload";
    ControlType["ItemList"] = "ItemList";
    ControlType["CheckList"] = "CheckList";
    ControlType["Foreach"] = "Foreach";
    ControlType["DataGrid"] = "DataGrid";
    ControlType["DateTime"] = "DateTime";
    ControlType["Date"] = "Date";
    ControlType["Time"] = "Time";
    ControlType["Editor"] = "Editor";
    ControlType["Expander"] = "Expander";
    ControlType["Label"] = "Label";
    ControlType["Numeric"] = "Numeric";
    ControlType["Scan"] = "Scan";
    ControlType["YesNoButton"] = "YesNoButton";
    ControlType["List"] = "List";
    ControlType["Detail"] = "Detail";
    ControlType["FullCalendar"] = "FullCalendar";
    ControlType["Page"] = "Page";
    ControlType["Fieldset"] = "Fieldset";
    ControlType["Textarea"] = "Textarea";
    ControlType["Tree"] = "Tree";
    ControlType["Dialog"] = "Dialog";
    ControlType["Table"] = "Table";
    ControlType["TableColumn"] = "TableColumn";
    ControlType["TableRow"] = "TableRow";
    ControlType["Text"] = "Text";
    ControlType["Spacer"] = "Spacer";
    ControlType["SelectGrid"] = "SelectGrid";
    ControlType["Secret"] = "Secret";
    ControlType["Permissions"] = "Permissions";
    ControlType["Spreadsheet"] = "Spreadsheet";
})(ControlType || (ControlType = {}));
export var ControlTheme;
(function (ControlTheme) {
    ControlTheme["Native"] = "Native";
    ControlTheme["Spreadsheet"] = "Spreadsheet";
})(ControlTheme || (ControlTheme = {}));
export var PageType;
(function (PageType) {
    PageType["Default"] = "Default";
    PageType["SplitScreen"] = "SplitScreen";
    PageType["MobileScreen"] = "MobileScreen";
})(PageType || (PageType = {}));
export var PushNotificationType;
(function (PushNotificationType) {
    PushNotificationType["Push"] = "Push";
    PushNotificationType["Overlay"] = "Overlay";
})(PushNotificationType || (PushNotificationType = {}));
export var SpecificAction;
(function (SpecificAction) {
    SpecificAction["Close"] = "Close";
    SpecificAction["Submit"] = "Submit";
})(SpecificAction || (SpecificAction = {}));
export var ApplicationDevice;
(function (ApplicationDevice) {
    ApplicationDevice["Desktop"] = "Desktop";
    ApplicationDevice["Mobile"] = "Mobile";
})(ApplicationDevice || (ApplicationDevice = {}));
export var ValueDataType;
(function (ValueDataType) {
    ValueDataType["String"] = "string";
    ValueDataType["Number"] = "number";
    ValueDataType["Enum"] = "enum";
    ValueDataType["Unknown"] = "unknown";
})(ValueDataType || (ValueDataType = {}));
export var LabelPosition;
(function (LabelPosition) {
    LabelPosition["Left"] = "Left";
    LabelPosition["Top"] = "Top";
    LabelPosition["Right"] = "Right";
})(LabelPosition || (LabelPosition = {}));
export var ComplexFilterItemType;
(function (ComplexFilterItemType) {
    ComplexFilterItemType["Text"] = "Text";
    ComplexFilterItemType["Number"] = "Number";
    ComplexFilterItemType["Boolean"] = "Boolean";
    ComplexFilterItemType["Date"] = "Date";
    ComplexFilterItemType["Enum"] = "Enum";
})(ComplexFilterItemType || (ComplexFilterItemType = {}));
export var MultiplicationType;
(function (MultiplicationType) {
    MultiplicationType["Agregated"] = "Agregated";
    MultiplicationType["Desintegrated"] = "Desintegrated";
})(MultiplicationType || (MultiplicationType = {}));
export var ColorType;
(function (ColorType) {
    ColorType["Default"] = "Default";
    ColorType["Primary"] = "Primary";
    ColorType["Secondary"] = "Secondary";
})(ColorType || (ColorType = {}));
export var StyleType;
(function (StyleType) {
    StyleType["Contained"] = "Contained";
    StyleType["Outlined"] = "Outlined";
    StyleType["Text"] = "Text";
    StyleType["Icon"] = "Icon";
})(StyleType || (StyleType = {}));
export var SizeType;
(function (SizeType) {
    SizeType["Small"] = "Small";
    SizeType["Medium"] = "Medium";
    SizeType["Large"] = "Large";
    SizeType["Full"] = "Full";
})(SizeType || (SizeType = {}));
export var DialogSize;
(function (DialogSize) {
    DialogSize["Auto"] = "Auto";
    DialogSize["FullSize"] = "FullSize";
})(DialogSize || (DialogSize = {}));
export var DateTimeControlType;
(function (DateTimeControlType) {
    DateTimeControlType["DateTime"] = "DateTime";
    DateTimeControlType["Date"] = "Date";
    DateTimeControlType["Time"] = "Time";
})(DateTimeControlType || (DateTimeControlType = {}));
export var SelectMode;
(function (SelectMode) {
    SelectMode["None"] = "None";
    SelectMode["Single"] = "Single";
    SelectMode["Multiple"] = "Multiple";
})(SelectMode || (SelectMode = {}));
export var SelectGridViewMode;
(function (SelectGridViewMode) {
    SelectGridViewMode["Inline"] = "Inline";
    SelectGridViewMode["Dropdown"] = "Dropdown";
    SelectGridViewMode["Dialog"] = "Dialog";
})(SelectGridViewMode || (SelectGridViewMode = {}));
export var NumericType;
(function (NumericType) {
    NumericType["Input"] = "Input";
    NumericType["Numpad"] = "Numpad";
})(NumericType || (NumericType = {}));
//# sourceMappingURL=api.js.map